import React, { forwardRef } from 'react';
import type { CircularProgressProps } from '@mui/material';
import { CircularProgress as CircularProgressMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

const sizes = {
  x5Small: 8,
  x4Small: 10,
  x3Small: 12,
  x2Small: 14,
  xSmall: 16,
  small: 18,
  medium: 20,
  large: 24,
  xLarge: 28,
  x2Large: 32,
  x3Large: 36,
  x4Large: 40,
  x5Large: 44,
  x6Large: 48,
  x7Large: 52,
  x8Large: 56,
  x9Large: 60,
};

const CircularProgress = forwardRef<HTMLElement, CircularProgressProps>((props, ref) => {
  const svgProps: CircularProgressProps = omitUndefinedProps({
    ...props,
    size: sizes[props.size as keyof typeof sizes] ?? props.size,
  });

  return <CircularProgressMUI {...svgProps} ref={ref} />;
});

CircularProgress.displayName = 'CircularProgress';

export default CircularProgress;
